module.exports = __webpack_public_path__ + "assets/img/vemproapp_generica_restaurante_feed.64853425.png";